export const isMobile = (): boolean => {
  return (
    typeof window === "undefined" ||
    (typeof navigator !== "undefined" && navigator.product === "ReactNative")
  );
};
